/**
 * 创建懒加载代理：立即触发动态 import，模块加载完成前通过 Proxy 转发属性访问。
 * 由于模板中的属性访问（如 $util.akamai）发生在组件渲染时（远晚于插件初始化），
 * 动态 import 的模块此时已加载完毕，因此不会出现属性未定义的情况。
 */
function createLazyProxy(loader) {
  const target = {};
  loader().then((mod) => Object.assign(target, mod));
  return target;
}

export default defineNuxtPlugin(async (nuxtApp) => {
  // 服务端需要同步可用，客户端使用懒加载
  let util, priceUtil;

  if (process.server) {
    [util, priceUtil] = await Promise.all([
      import('@/assets/js/utils'),
      import('@/assets/js/currency-price'),
    ]);
  } else {
    // 客户端懒加载，vite 会将它们打包到 util-chunk 中
    util = createLazyProxy(() => import('@/assets/js/utils'));
    priceUtil = createLazyProxy(() => import('@/assets/js/currency-price'));
  }

  nuxtApp.provide('util', util);
  nuxtApp.provide('priceUtil', priceUtil);

  nuxtApp.vueApp.provide('util', util);
  nuxtApp.vueApp.provide('priceUtil', priceUtil);
});
